
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/offerings",
      function () {
        return require("private-next-pages/solutions/offerings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/offerings"])
      });
    }
  